const SET_CREATE_CRQ_PEER_REVIEWER = 'SET_CREATE_CRQ_PEER_REVIEWER';
const SET_CREATE_CRQ_PEER_REVIEWER_GROUP = 'SET_CREATE_CRQ_PEER_REVIEWER_GROUP';


const setCreateCrqPeerReviewer = (peerReviewer) => ({
  type: SET_CREATE_CRQ_PEER_REVIEWER,
  payload: {
    peerReviewer,
  },
});

const setCreateCrqPeerReviewerGroup = (peerReviewerGroup) => ({
  type: SET_CREATE_CRQ_PEER_REVIEWER_GROUP,
  payload: {
    peerReviewerGroup,
  },
});


export {
  setCreateCrqPeerReviewer,
  setCreateCrqPeerReviewerGroup,
  SET_CREATE_CRQ_PEER_REVIEWER,
  SET_CREATE_CRQ_PEER_REVIEWER_GROUP,
};
